export default __webpack_public_path__ + "static/media/testimonials1.e9b268da.jpg";